module.exports = __webpack_public_path__ + "static/shaun.4b2caf45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/master_class/shaun.png
// module id = 573
// module chunks = 149428911916780